<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title50"></a>
<div class="p-c"><span><em class="i">For Julie, Margaret and Henry: Moira and Todd—</em></span></div>
<div class="p-c"><span><em class="i">A story of your tomorrow.</em></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466822825_ded01.vue?541ac86f